<template>
    <v-slide-y-reverse-transition>
      <v-flex xs12 class="py-3 px-3 email-attach-bar" v-show="showClipboardBar">
        <v-layout wrap>
          <div style="position:absolute; top:13px; right:20px">
            <v-btn
              color="success" depressed class="ma-0"
              :disabled="!canAttach"
              @click="attachToCaseReturnToCommsroom()">
              Attach
              <span class="hidden-sm-and-down ml-1">to case & Return to Commsroom</span>
            </v-btn>
            &nbsp;
            <v-btn
              color="success" depressed class="ma-0"
              :disabled="!canAttach"
              @click="attachToCase()">
              Attach
              <span class="hidden-sm-and-down ml-1">to case</span>
            </v-btn>
            <v-tooltip left color="secondary">
              <v-btn
                slot="activator"
                dark
                flat
                icon
                class="ma-0 ml-2"
                @click="cancelClipboard()">
                <v-icon color="white">cancel</v-icon>
              </v-btn>
              <span>Cancel attachement</span>
            </v-tooltip>
          </div>
          <v-flex
            class="d-block py-1"
            xs12
            style="padding-right:250px"
            :class="{'fixed-bar': $vuetify.breakpoint.smAndDown}">
            <font-awesome-icon
              class="ml-1 mr-3"
              size="lg"
              :icon="icon"
              style="vertical-align:middle;color:white">
            </font-awesome-icon>
            <h4
              class="d-inline-block text-truncate unread pr-1"
              style="vertical-align:middle; max-width:50%">
              {{content}}
            </h4>
            <div
              class="pl-0 text-truncate hidden-sm-and-down"
              style="vertical-align:middle; max-width:25%; display:inline-block">
              <span class="last-sender pr-2 pl-2 body-1 opacity-54">{{content2}}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-slide-y-reverse-transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "clipboard-bar",
  data: () => ({
    showClipboardBar: false,
    icon: "folder",
    action: "",
    target: "",
    content: "",
    content2: "",
    canAttach: false
  }),
  computed: {
    ...mapState({
      copiedMessage: state => state.ui.clipboard.commsMessage,
      currentPath: state => state.cbroute.path,
      caseId: state => state.cbroute.params.case_id,
      pageSize: state => state.currentUser.me.preferences.pageSize ? state.currentUser.me.preferences.pageSize : 10
    })
  },
  watch: {
    copiedMessage() {
      if (this.copiedMessage) { this.setupCommsMessage() }
    },
    currentPath() {
      const parts = this.currentPath.split("/")
      if (parts[0] === "" && parts[1] === "case") {
        this.canAttach = true
      } else {
        this.canAttach = false
      }
    }
  },
  methods: {
    setupCommsMessage() {
      this.icon = "envelope"
      this.content = this.copiedMessage.subject
      this.content2 = this.copiedMessage.from.displayName
      this.showClipboardBar = true
    },
    async attachToCase() {
      const ids = { conversationId: parseInt(this.copiedMessage.conversation.id), caseId: "" + this.caseId }
      await this.$store.dispatch("attachConversationToCase", ids)
      await this.$store.dispatch("getCurrentlySelectedCase", { caseId: this.caseId })
      this.cancelClipboard()
    },
    async attachToCaseReturnToCommsroom() {
      const ids = { conversationId: parseInt(this.copiedMessage.conversation.id), caseId: "" + this.caseId }
      await this.$store.dispatch("attachToCaseReturnToCommsroom", ids)
      this.cancelClipboard()
    },
    cancelClipboard() {
      this.$store.dispatch("clearClipboard")
      this.showClipboardBar = false
    }
  }
}
</script>
